import Component from './BadgeSeparator.component';

export default Component;
